// Navigation Links (will be translated in component)
export const getNavLinks = (t) => [
  { label: t("nav.aboutBlueberry"), href: "/blueberry-sensei" },
  { label: t("nav.becomeCreator"), href: "https://hope.phuongai.com" },
  { label: t("nav.center"), href: "/center" },
  { label: t("nav.support"), href: "mailto:contact@phuongai.com" },
];
